import { ANALYTICS_REPORT_FAILURE, ANALYTICS_REPORT_SUCCESS } from "./analytics.actionTypes";


const initialState = {
  analyticsReport: [],
};

export default function analyticsReducer(state = initialState, { type, payload }) {
  switch (type) {

    case ANALYTICS_REPORT_SUCCESS:
      return {
        ...state,
        analyticsReport: payload,
      };
    case ANALYTICS_REPORT_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
